// 대화 기록 거르기·쪽 나누기 — 화면과 떨어진 순수 함수(계약 §13)
export const PER = 15;
export const EMPTY = { from: "", to: "", lang: "", ch: "", cat: null, q: "", res: "" };

export const seoulToday = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Seoul" });

function minusDays(ymd, n) {
    const d = new Date(`${ymd}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() - n);
    return d.toISOString().slice(0, 10);
}

// 다른 메뉴가 넘긴 { lang?, quick_category_id?, q?, days? } → 첫 거르기
export function initialFilter(params, today = seoulToday()) {
    const p = params || {};
    const f = { ...EMPTY };
    if (p.days > 0) { f.from = minusDays(today, p.days - 1); f.to = today; }
    if (p.lang) f.lang = p.lang;
    if (p.quick_category_id != null) f.cat = Number(p.quick_category_id);
    if (p.q) f.q = String(p.q);
    return f;
}

// page 를 주면 offset·limit 까지(목록), 안 주면 거르기만(건수·키워드·엑셀)
export function toParams(f, page) {
    const p = {};
    if (f.from) p.date_from = f.from;
    if (f.to) p.date_to = f.to;
    if (f.lang) p.lang = f.lang;
    if (f.ch) p.channel = f.ch;
    if (f.cat != null) p.quick_category_id = f.cat;
    const q = (f.q || "").trim();
    if (q) p.q = q;
    if (f.res) p.status = f.res;
    if (page) { p.offset = (page - 1) * PER; p.limit = PER; }
    return p;
}

export function pageWindow(p, pages) {
    const win = [];
    for (let i = Math.max(1, p - 2); i <= Math.min(pages, p + 2); i++) win.push(i);
    if (win[0] > 1) { if (win[0] > 2) win.unshift("…"); win.unshift(1); }
    if (win[win.length - 1] < pages) { if (win[win.length - 1] < pages - 1) win.push("…"); win.push(pages); }
    return win;
}

export const isActive = (f) => !!(f.lang || f.ch || f.cat != null || f.from || f.to || (f.q || "").trim());

export function linkKind(s) {
    if (s.inquiry_id != null) return "linked";
    if (s.result === "escalated") return "missing";
    return "none";
}

export const RES = { answered: ["ok", "응답"], failed: ["fail", "실패"], escalated: ["esc", "확인필요"] };
export const LANGS = [["ko", "한국어"], ["zh", "中文"], ["en", "English"], ["ja", "日本語"]];
export const CHANNELS = [["web", "웹"], ["mobile", "모바일"]];
export const langTxt = (l) => (LANGS.find((x) => x[0] === l) || [null, l || "-"])[1];
export const chTxt = (c) => (CHANNELS.find((x) => x[0] === c) || [null, c || "-"])[1];
export const storeName = (s) => s?.store?.name || "매장 미상";
export const nf = (v) => Number(v || 0).toLocaleString("ko-KR");
